import Vue from 'vue'
import VueRouter from 'vue-router'
// import Aidex from '../views/Aidex.vue'
// import AidexMg from '../views/AidexMg.vue'
import Bg from '../views/Bg.vue'
import Pump from '../views/Pump.vue'
import Mix from '../views/Mix.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/bg'
  },
  {
    path: '/bg',
    name: 'Bg',
    component: Bg
  },
  {
    path: '/pump',
    name: 'Pump',
    component: Pump
  },
  {
    path: '/print',
    name: 'Mix',
    component: Mix
  }// ,
  // // 中文aidex
  // {
  //   path: '/aidex',
  //   name: 'Aidex',
  //   component: Aidex
  // },
  // // mg/dL版本 aidex
  // {
  //   path: '/mg/aidex',
  //   name: 'AidexMg',
  //   component: AidexMg
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
